'use strict';

export function routeConfig($urlRouterProvider, $locationProvider, $httpProvider) {
  'ngInject';

  if(!$httpProvider.defaults.headers.common) {
    $httpProvider.defaults.headers.common = {};
  }
  $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.common.Pragma = 'no-cache';
  $httpProvider.defaults.headers.common['If-Modified-Since'] = '0';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);
}



// WEBPACK FOOTER //
// ./client/app/app.config.js